import React, { useEffect, useRef, useState } from "react";
import { Col, Row, Form, Input, DatePicker, message } from "antd";
import moment from "moment";
import MedicalService from "../../../../Services/MedicalHistoryService";
import PatientService from "../../../../Services/PatientService";

function AddFamilyHistory(props) {
  const [form] = Form.useForm();
  const [givenDate, setGivenDate] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [selectedPatientDetails, setSelectedPatientDetails] = useState(null);

  useEffect(() => {
    fetchPatientDetails(props.selectedPatient?.patientId)
  }, [props]);

  const fetchPatientDetails = async (Id) => {
    const payload = {
      patientId: Id
    }
    try {
      const response = await PatientService.PatientListFilter(payload);
      setSelectedPatientDetails(response.data[0]);
    }
    catch (e) {
      console.log(e)
    }
  }

  const formRef = useRef();
  const { TextArea } = Input;

  const handleCancel = () => {
    formRef.current.resetFields();
    setGivenDate('');
    props.onClose();
  };

  const handleDate = (date, dateString) => {
    if (dateString) {
      const constructedTime = dateString + " " + "00:00:00";
      setGivenDate(constructedTime);
    }
    else {
      setGivenDate('');
    }
  }

  const disabledFutureDate = (current) => {
    return current && current > moment().endOf("day");
  };

  const onFinish = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const userObj = sessionStorage.getItem('login_result')
    const userData = userObj ? JSON.parse(userObj) : null;

    const currDate = new Date().toISOString();
    const date = currDate.split('T')[0];
    const time = currDate.split('T')[1].slice(0, 8);
    const constructedTime = date + " " + time;

    const { description } = formRef.current.getFieldValue();
    if (!description || !givenDate) {
      message.error("Please fill all fields");
      setIsLoading(false);
      return;
    }
    let payload = {
      account_Id: props.selectedPatient?.account_Id,
      clinic_Id: props.selectedPatient?.clinic_Id,
      userId: props.selectedPatient?.userId,
      createdDate: constructedTime,
      givenDate: givenDate,
      createdBy: userData?.user?.userId,
      modifiedBy: userData?.user?.userId,
      status: 1,
      patientId: props.selectedPatient?.patientId,
      description: description,
      patientBloodGroup: selectedPatientDetails?.bloodGroup,
      patientDob: selectedPatientDetails?.dob,
      patientEmail: selectedPatientDetails?.email,
      patientName: selectedPatientDetails?.firstName,
      modifiedDate: constructedTime,
      fromDate: givenDate,
      toDate: givenDate,
    };
    try {
      const saveResponse = await MedicalService.AddFamilyHistory(payload);
      if (saveResponse.data === 1) {
        let getPayload = {
          account_Id: payload.account_Id,
          userId: (props.permissionData === null || props.permissionData === "N") ? props.selectedPatient?.userId : '',
          patientId: payload.patientId,
          status: 1,
        };
        const getResponse = await MedicalService.PatientFamilyHistory(getPayload);
        formRef.current.resetFields();
        props.handleLatestUpdate(getResponse.data);
        setIsLoading(false);
        props.onClose();
      }
    }
    catch (e) {
      console.log(e);
      setIsLoading(false);
    }
  };

  return (
    <div>
      <Form
        name="basic"
        labelCol={{
          span: 24,
        }}
        wrapperCol={{
          span: 24,
        }}
        form={form}
        ref={formRef}
        disabled={isLoading}
      >
        <Row gutter={20}>
          <Col className="gutter-row" span={12}>
            <Form.Item
              label={
                <span className="font-medium">
                  Family History{" "}
                  <span style={{ color: "#FF000F" }}>*</span>
                </span>
              }
              name="description"
            >
              <TextArea rows={3} placeholder="Enter Family History" />

            </Form.Item>
          </Col>

          <Col className="gutter-row" span={12}>
            <Form.Item label={<span className="font-medium">Date{" "}<span style={{ color: "#FF000F" }}>*</span></span>} name="givenDate">
              <DatePicker
                style={{ width: "100%" }}
                placeholder="Select"
                format="YYYY-MM-DD"
                onChange={handleDate}
                disabledDate={disabledFutureDate}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <Col className="gutter-row" span={24}>
        <div className="flex items-center w-full justify-end my-5">
          <button
            onClick={handleCancel}
            disabled={isLoading}
            className="rounded-md text-sm px-6 py-1.5 bg-white border border-brand-primaryColor text-brand-primaryColor disabled:cursor-not-allowed disabled:opacity-50"
          >
            Cancel
          </button>
          <button disabled={isLoading} onClick={onFinish} className="custom_filter rounded-md px-5 py-1.5 text-white text-sm ml-3 disabled:cursor-not-allowed disabled:opacity-50">
            Submit
          </button>
        </div>
      </Col>
    </div>
  );
}
export default AddFamilyHistory

